import React from "react";
import {
  Divider,
  makeStyles,
  Box
} from "@material-ui/core";
import { colors } from "swyft-react-core";

const useStyles = makeStyles(() => ({
  hr: {
  },
  hrShadow: {
    border: 0,
    borderBottom: "1px solid " + colors.lighterGrey,
    boxSizing: "content-box",
    height: "10px",
    boxShadow: "0px 3px 6px 0px rgba(0, 0, 0, 0.16)",
    backgroundColor: "transparent",
    marginTop: "-10px"
  }
}));

interface QuoteHrProps {
  shadow?: boolean;
  [x:string]: any;
}

export const QuoteHr: React.FC<QuoteHrProps> = ({
  shadow,
  ...rest
}) => {
  const classes = useStyles();

  const className = shadow ? classes.hrShadow : classes.hr;

  return <Box 
    {...rest}
  >
    <Divider className={className} />
  </Box>
};